export default {
    isAuth: !!localStorage.getItem('btm_token'),
    isLoading: false,
}